import styled from "styled-components";
import waves from "../assets/videos/bg-video.mp4";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi2";

const StyledPageNotFound = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100vh;
`;

const Video = styled.video`
  height: 100%;
  left: 0;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
`;

const Redirect = styled.div`
  position: absolute;
  z-index: 9999;
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
  gap: 1rem;

  font-size: larger;
  font-weight: bold;
`;

const NotFoundContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  
`;

const StyledLink = styled(Link)`
  display: flex;
  gap: 1rem;
  align-items: center;

  color: white;
`;

/**
 * This React component renders a "Not Found" page to inform users
 * that the requested page does not exist.
 * 
 * Features:
 * - Shows a descriptive text indicating the page is not found
 * - Provides a button to navigate back to the Use Cases page
 * 
 * @returns {JSX.Element} A JSX.Element that renders a "Not Found" page
 */
function PageNotFound() {
  return (
    <StyledPageNotFound>
      <Video autoPlay muted loop id="waves">
        <source src={waves} type="video/mp4" />
      </Video>

      <Redirect>
        <NotFoundContent>
          <p>There is still a lot to explore in the oceans.</p>
          <p>This path is not one of them.</p>
        </NotFoundContent>

        <StyledLink to="/">
          Home
          <HiArrowRight />
        </StyledLink>
      </Redirect>
    </StyledPageNotFound>
  );
}

export default PageNotFound;
